// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c186181b","453":"73a2c132","455":"63e70111"}[chunkId] + ".chunk.js";
};